/*require('../theme/css/bootstrap.css');
require('../theme/css/style.css');
require('../theme/font-awesome/css/font-awesome.css');
require('../theme/css/animate.css');
require('angular-datatables/src/plugins/bootstrap/datatables.bootstrap.css');
require('../theme/css/plugins/dropzone/basic.css');
require('../theme/css/plugins/dropzone/dropzone.css');
require('../theme/css/plugins/steps/jquery.steps.css');
require('../css/style.css');
require('../theme/css/plugins/iCheck/custom.css');
require('../theme/js/plugins/iCheck/icheck.min.js');
require('../theme/css/plugins/colorpicker/colorpicker.css');
require('../theme/js/plugins/colorpicker/bootstrap-colorpicker-module.js');
require('../theme/css/plugins/google/autocomplete.css');
require('../theme/js/plugins/google/autocomplete.js');*/
require('slick-carousel/slick/slick.js');
require('angular-slick-carousel/dist/angular-slick.js');
require('angular-clipboard/angular-clipboard.js');
require('angular-youtube-embed/dist/angular-youtube-embed.min');
require('angular-file-saver/dist/angular-file-saver.bundle.min');
require('magnific-popup/dist/jquery.magnific-popup.js');
require('magnific-popup/dist/magnific-popup.css');
require('angular-datepicker/dist/index.min');
require('angular-datepicker/dist/index.css');

import toastr from 'angular-toastr';
module.exports = angular
    .module('lipsApp', [
        'ui.router',
        'ct.ui.router.extras.future',
        'ui.bootstrap',
        'ngAnimate',
        'oc.lazyLoad',
        'ui.select',
        'slickCarousel',
        'angular-clipboard',
        'youtube-embed',
        'ngFileSaver',
        'datePicker',
        toastr,
        require('./shared/shared.module').name,
        require('./translation/translation.module').name
    ])
    .run(function($rootScope, $state, $location) {
        $rootScope.$state = $state;
        $rootScope.vcsRevision = '##VCS_REVISION##';
        $rootScope.IMAGE_MAX_SIZE = (1024 * 1024 * 10);
        const search = $location.search();
        if (search.startLogin) {
            $location.search('startLogin', null);
        }
    })
    .factory('mapService', function($rootScope) {
        const bs = {
            _subs: [],
            _latestVal: null,
            next: (val) => {
                bs._latestVal = val;
                bs._subs.forEach(s => s(val))
            },
            subscribe: (cb) => {
                bs._subs.push(cb);
                if (bs._latestVal) {
                    cb(bs._latestVal);
                }
                return () => {
                    if(bs._subs.indexOf(cb) > -1) bs._subs.splice(bs._subs.indexOf(cb), 1)
                };
            }
        }; //new BehaviourSubject(null);
        window.addEventListener("message", (e) => {
            $rootScope.$apply(() => {
                //$rootScope.$broadcast('onWindowMessage', e.data);
                bs.next(e.data);
            });
        }, false);
        return bs;
    })
    .constant('systemIcons', {

        features: {
            outdoor: [
                'wheelchair_sign_at_a_bus_stop',
                'wheelchair_sign_at_a_bus_stop_no',
                'information_board',
                'car_parks_and_disabled_people_parking',
                'family_parking', 'sound_traffic_light', 'intersection_timer', 'directional_and_grandmother_stones', 'barrier', 'paid_parking'],
            doors: ['standard_door_manually_opened', 'standard_door_manually_opened_narrow', 'standard_door_open_automatically_or_with_a_button', 'sliding_doors', 'revolving_doors', 'alternative_entrance', 'high_border', 'steep_climb_on_the_sidewalk', 'dilapidated_sidewalk'],
            lifts: ['accesibility_lift', 'lift', 'vertical_lift_wheelchair_lift', 'stair_lift', 'stair_climbers', 'lift_audio', 'controls_relief_or_braille', 'escalator', 'travelator'],
            stairs: ['disabled_access_ramp_5', 'disabled_access_ramp_6_10', 'disabled_access_ramp_10', 'handrail', 'steps_without_handrails', 'steps_with_handrails', ''],
            wc: ['disabled_toilet', 'disabled_toilet_design', 'disabled_toilet_design_no_left', 'disabled_toilet_design_no_right', 'possibility_of_baby_wraps', 'possibility_of_baby_toilet'],
            indoor: ['audio_sign_sound_beacon', 'floor_plan', 'tactile_door_signs', 'service_and_cash_registers', 'shelves_cabinets_and_wardrobes', 'blind_eye', 'old_people', 'blind', 'disabled_shower', 'pool_lift', 'available_water'],
            services: ['mobile_equipment_rental', 'hearing_impaired', 'power_socket', 'wifi', 'luggage_office', 'large_font', 'сapture_exhibit_allowed', 'guide-dog', 'designation_for_the_blind', 'audio_sign_atm', 'induction_loop', 'deaf_and_dumb', 'subtitles', 'bed_disabled', 'wc', 'shopping_cart'],
            accessibility: ['accesibility_sign', 'wheelchair_back_assistant', 'wheelchair_no_access', 'electric_wheelchair_no_access', 'electric_wheelchair', 'scooter', 'scooter_no_access', 'baby_carriage', 'baby_carriage_no_access']
        },
        categories: {categories: ['state_and_public_institutions', 'school', 'business', 'medical', 'house', 'culture_and_leisure', 'food', 'transport', 'disabled_parking', 'walking', 'public_shelter']},
        obstacles: {obstacles: ['high_border', 'steep_climb_on_the_sidewalk', 'dilapidated_sidewalk', 'open_gutter', 'road_hatch', 'paving_stones', 'steps_along_the_way', 'another_obstacle']},
    })
    .config(function($urlRouterProvider, $futureStateProvider, uibDatepickerConfig, uibDatepickerPopupConfig, toastrConfig) {
        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            newestOnTop: true,
            positionClass: 'toast-top-center',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    });



/** WEBPACK FOOTER **
 ** ./app/app.js
 **/